import React, { useState } from 'react';

const s = {
  page: {
    minHeight: '100vh',
    background: '#0f0f12',
    color: '#fff',
    fontFamily: "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, sans-serif",
    padding: '0 0 60px',
  },
  header: {
    background: 'rgba(15,15,18,.9)',
    backdropFilter: 'blur(16px)',
    borderBottom: '1px solid rgba(255,255,255,.08)',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'sticky',
    top: 0,
    zIndex: 50,
  },
  logo: {
    fontSize: 20,
    fontWeight: 900,
    letterSpacing: 1,
    color: '#fff',
    WebkitTextStroke: '1.5px #00ff99',
    textShadow: '0 0 10px rgba(0,255,136,.4)',
    textDecoration: 'none',
  },
  backBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    color: 'rgba(255,255,255,.5)',
    textDecoration: 'none',
    fontSize: 14,
    fontWeight: 600,
    padding: '8px 14px',
    borderRadius: 10,
    border: '1px solid rgba(255,255,255,.1)',
    background: 'rgba(255,255,255,.04)',
  },
  wrap: {
    maxWidth: 720,
    margin: '0 auto',
    padding: '40px 24px',
  },
  badge: {
    display: 'inline-block',
    background: 'linear-gradient(135deg,#00ff99,#00e5ff)',
    color: '#000',
    fontSize: 11,
    fontWeight: 800,
    padding: '4px 12px',
    borderRadius: 20,
    letterSpacing: .5,
    textTransform: 'uppercase',
    marginBottom: 16,
  },
  title: {
    fontSize: 32,
    fontWeight: 900,
    color: '#fff',
    margin: '0 0 8px',
    lineHeight: 1.1,
  },
  tagline: {
    fontSize: 16,
    color: 'rgba(255,255,255,.5)',
    margin: '0 0 40px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  divider: {
    height: 1,
    background: 'rgba(255,255,255,.07)',
    margin: '36px 0',
  },
  sectionLabel: {
    fontSize: 11,
    fontWeight: 800,
    textTransform: 'uppercase',
    letterSpacing: 1,
    color: '#00ff99',
    marginBottom: 16,
  },
  faqList: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  faqItem: {
    border: '1px solid rgba(255,255,255,.08)',
    borderRadius: 16,
    overflow: 'hidden',
    transition: 'border-color .15s',
  },
  faqItemOpen: {
    border: '1px solid rgba(0,255,136,.2)',
  },
  faqBtn: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 12,
    padding: '18px 20px',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    textAlign: 'left',
    color: '#fff',
    fontFamily: 'inherit',
  },
  faqQ: {
    fontSize: 15,
    fontWeight: 700,
    color: '#fff',
    lineHeight: 1.4,
    flex: 1,
  },
  faqChevron: {
    flexShrink: 0,
    fontSize: 16,
    color: 'rgba(255,255,255,.35)',
    transition: 'transform .2s, color .15s',
    lineHeight: 1,
  },
  faqChevronOpen: {
    color: '#00ff99',
  },
  faqAnswer: {
    padding: '0 20px 18px',
    fontSize: 15,
    lineHeight: 1.75,
    color: 'rgba(255,255,255,.65)',
    borderTop: '1px solid rgba(255,255,255,.05)',
    marginTop: -1,
  },
  contactCard: {
    background: 'rgba(0,255,136,.05)',
    border: '1px solid rgba(0,255,136,.15)',
    borderRadius: 20,
    padding: '32px 28px',
    textAlign: 'center',
  },
  contactIcon: {
    fontSize: 36,
    marginBottom: 12,
    lineHeight: 1,
  },
  contactTitle: {
    fontSize: 20,
    fontWeight: 800,
    color: '#fff',
    margin: '0 0 8px',
  },
  contactText: {
    fontSize: 15,
    color: 'rgba(255,255,255,.55)',
    margin: '0 0 24px',
    lineHeight: 1.6,
  },
  emailBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8,
    background: 'linear-gradient(135deg,#00ff99,#00e5ff)',
    color: '#000',
    textDecoration: 'none',
    fontWeight: 800,
    fontSize: 15,
    padding: '14px 28px',
    borderRadius: 12,
    transition: 'transform .15s',
  },
  billingNote: {
    marginTop: 20,
    padding: '14px 18px',
    background: 'rgba(255,255,255,.03)',
    border: '1px solid rgba(255,255,255,.07)',
    borderRadius: 12,
    fontSize: 13,
    color: 'rgba(255,255,255,.45)',
    lineHeight: 1.6,
  },
  footer: {
    marginTop: 48,
    paddingTop: 24,
    borderTop: '1px solid rgba(255,255,255,.07)',
    display: 'flex',
    flexWrap: 'wrap',
    gap: 16,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  footerLinks: {
    display: 'flex',
    gap: 20,
    flexWrap: 'wrap',
  },
  footerLink: {
    color: 'rgba(255,255,255,.4)',
    textDecoration: 'none',
    fontSize: 13,
    fontWeight: 600,
  },
  footerText: {
    color: 'rgba(255,255,255,.25)',
    fontSize: 12,
  },
};

const FAQS = [
  {
    q: 'How do I get started with Tracksy?',
    a: 'Sign in at app.tracksyhq.com. Once logged in, start logging your daily sales activity from the Dashboard tab. Your commissions calculate automatically — just set your monthly goal in your Profile and the app does the rest.',
  },
  {
    q: 'How are my commissions calculated?',
    a: 'Tracksy calculates your projected commissions based on your logged deals, appointments, and follow-ups. The Earnings tab shows your full breakdown — front gross, back gross, spiffs, and bonus tiers. You can configure your commission percentages and bonus structure in your Profile settings.',
  },
  {
    q: 'How do I cancel my subscription?',
    a: 'Go to your Account settings within the app and click "Manage Billing." This opens the Stripe customer portal where you can cancel your subscription, update your payment method, or download past invoices. Cancellations take effect at the end of your current billing period — you keep access until then.',
  },
  {
    q: 'Is my sales data private?',
    a: 'Yes. Your data is stored securely in Google Firebase and is never shared with or visible to other users, dealerships, managers, or any third parties (other than the service providers required to run the app). See our Privacy Policy for full details on how we handle your data.',
  },
  {
    q: "The app isn't loading. What should I do?",
    a: 'Try a hard refresh first: Ctrl+Shift+R on Windows/Chrome, or Cmd+Shift+R on Mac/Safari. If the issue persists, clear your browser cache or try a different browser. If you installed Tracksy as a PWA (home screen app), try uninstalling it and reinstalling from app.tracksyhq.com. If none of that works, email us and we\'ll look into it.',
  },
  {
    q: 'I forgot which email I used to sign in.',
    a: 'Your account is tied to the email address you used when you first signed up. Try any email addresses you may have used. If you still can\'t find it, email us at tracksysales@gmail.com and we can look up your account.',
  },
];

function FaqItem({ q, a }) {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ ...s.faqItem, ...(open ? s.faqItemOpen : {}) }}>
      <button
        style={s.faqBtn}
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span style={s.faqQ}>{q}</span>
        <span style={{
          ...s.faqChevron,
          ...(open ? s.faqChevronOpen : {}),
          transform: open ? 'rotate(180deg)' : 'rotate(0)',
        }}>▼</span>
      </button>
      {open && (
        <div style={s.faqAnswer}>{a}</div>
      )}
    </div>
  );
}

export default function SupportPage() {
  return (
    <div style={s.page}>
      {/* ── Header ── */}
      <header style={s.header}>
        <a href="https://app.tracksyhq.com" style={s.logo}>TRACKSY</a>
        <a href="https://app.tracksyhq.com" style={s.backBtn}>← Back to App</a>
      </header>

      <div style={s.wrap}>
        <div style={s.badge}>Support</div>
        <h1 style={s.title}>Tracksy Support</h1>
        <p style={s.tagline}>We're here to help you track more and worry less.</p>

        {/* ── FAQ ── */}
        <div style={s.sectionLabel}>Frequently asked questions</div>
        <div style={s.faqList}>
          {FAQS.map((item) => (
            <FaqItem key={item.q} q={item.q} a={item.a} />
          ))}
        </div>

        <div style={s.divider} />

        {/* ── Contact ── */}
        <div style={s.contactCard}>
          <div style={s.contactIcon}>✉️</div>
          <h2 style={s.contactTitle}>Still need help?</h2>
          <p style={s.contactText}>
            Send us a message and we'll get back to you within 1 business day.
          </p>
          <a
            href="mailto:tracksysales@gmail.com"
            style={s.emailBtn}
          >
            tracksysales@gmail.com
          </a>
          <div style={s.billingNote}>
            💳 &nbsp;<strong style={{ color: 'rgba(255,255,255,.65)' }}>Billing issues?</strong> Use the{' '}
            <strong style={{ color: 'rgba(255,255,255,.65)' }}>Manage Billing</strong> option in your
            account settings to access the Stripe customer portal directly — you can update payment
            info, download invoices, and manage your subscription there.
          </div>
        </div>

        {/* Footer */}
        <div style={s.footer}>
          <div style={s.footerLinks}>
            <a href="/terms" style={s.footerLink}>Terms of Service</a>
            <a href="/privacy" style={s.footerLink}>Privacy Policy</a>
            <a href="https://app.tracksyhq.com" style={s.footerLink}>Back to App</a>
          </div>
          <span style={s.footerText}>© 2026 Tracksy. All rights reserved.</span>
        </div>
      </div>
    </div>
  );
}
